import styled, { css } from "styled-components";

export const MobilePreviewHeading = styled.div`
    color: var(--calendar-text, #171A22);
    font-family: Manrope, Helvetica, sans-serif;
    font-size: ${p => p.size || "1.25rem"};
    font-weight: ${p => p.weight || 700};
    line-height: 1.3;
    margin: ${p => p.margin || "0"};
    text-align: center;
`;

export const MobilePreviewDot = styled.span`
    cursor: pointer;
    height: 5px;
    width: 5px;
    margin: 0 2px;
    background-color: var(--calendar-text, #171A22);
    border-radius: 50%;
    display: inline-block;
    opacity: ${p => p.isHighlighted ? 1 : 0.56};
    transition: background-color 0.6s ease, opacity 0.2s ease;

    ${p => p.isHighlighted && css`
        height: 10px;
        width: 10px;
    `}
`;

export const MobilePreviewArrowButton = styled.button`
    width: 56px;
    height: 56px;
    margin: ${p => p.margin || "0"};
    padding: 0;
    border: 0;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const MobilePreviewArrowImage = styled.img`
    width: 48px;
    height: 48px;
    object-fit: contain;
    filter: var(--calendar-preview-arrow-filter, none);
`;
